module.exports = __webpack_public_path__ + "static/media/nginx.e2b819e3.svg";